import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router } from '@angular/router';
import { NavService } from '@shared/services/nav.sevice';
import { AuthenticationService } from 'src/app/authentication.service';

@Injectable({
    providedIn: 'root'
})
export class PermissionGuardService implements CanActivate, CanActivateChild {

    constructor(
        private readonly navService: NavService, 
        private readonly authService: AuthenticationService,
        private readonly router: Router
    ) {}

    public canActivate(route: ActivatedRouteSnapshot): boolean {
        const expectedRole = (route.data as {expectedPermission: any}).expectedPermission;
        
        // Najpierw sprawdź czy użytkownik jest zalogowany
        if (!this.authService.authorizedUser) {
            // Użyj window.location.pathname zamiast router.url
            const currentUrl = window.location.pathname + window.location.search;
            
            if (currentUrl && currentUrl !== '/' && !currentUrl.includes('/login')) {
                sessionStorage.setItem('returnUrl', currentUrl);
            }
            
            this.navService.goToPage('/login');
            return false;
        }
        
        // Następnie sprawdź uprawnienia
        if (this.authService.checkPrivileges(expectedRole)) {
            return true;
        }

        // Zapisz obecny URL przed przekierowaniem do access-denied
        const currentUrl = window.location.pathname + window.location.search;
        
        if (currentUrl && currentUrl !== '/' && !currentUrl.includes('/login') && !currentUrl.includes('/access-denied')) {
            sessionStorage.setItem('returnUrl', currentUrl);
        }

        this.navService.goToPage('/access-denied', { permissions: expectedRole });
        return false;
    }

    public canActivateChild(): boolean {
        return true;
    }
}
